import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InviteUsersToStayComponent } from '@app/shared/components/invite-users-to-stay/invite-users-to-stay.component';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonList,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-invite-users-modal',
  imports: [
    ReactiveFormsModule,
    TranslocoPipe,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent,
    IonIcon,
    InviteUsersToStayComponent,
  ],
  templateUrl: './invite-users.modal.html',
  styleUrls: ['./invite-users.modal.scss'],
})
export class InviteUsersModalComponent {
  constructor(
    private _modalCtrl: ModalController,
    private _transloco: TranslocoService,
  ) {}

  onCancel() {
    this._modalCtrl.dismiss();
  }
}
